import { FORM_ELEMENT_TYPES, VALID_FORM_ELEMENT_TYPES } from './FormElements.types';

const doNothing = () => null;

export default class {
  type;

  onChange;

  otherProps;

  name;

  label;

  values;

  hiddenForRoles = [];

  disabledForRoles = [];

  allowNone = false;

  constructor(type, name, label, onChange, otherProps = {}, hiddenForRoles = [], disabledForRoles = []) {
    const isTypeValid = VALID_FORM_ELEMENT_TYPES.includes(type);
    this.name = name || '';
    this.type = isTypeValid ? type : FORM_ELEMENT_TYPES.GROUP;
    this.label = label || '';
    this.onChange = typeof onChange === 'function' ? onChange : doNothing;
    this.otherProps = otherProps;
    this.values = [];
    this.hiddenForRoles = hiddenForRoles;
    this.disabledForRoles = disabledForRoles;
  }
}
